<template>
  <b-modal :id="modalId" centered hide-header>

    <div style="position: relative" :class="{'text-center': textCenter}">
      <h4 v-if="title">{{ title }}</h4>
      <div class="d-block pt-3 px-3 custom-modal-checkin-detail__text" :class="{'scroll': scroll}">
        <p :class="textClass" v-html="text"></p>
      </div>
      <div class="custom-modal-checkin-detail__blur" v-if="scroll"></div>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <div class="w-100 text-center">
        <template v-if="ctas && ctas.length>0">
          <b-button v-for="(cta, index) in ctas" :key="index" :href="cta.url" variant="primary" block size="sm">
            {{ cta.label }}
          </b-button>
          <b-button @click="cancel()" variant="light" block size="sm">
            {{ $t('modal_custom_checkin_detail.btn_ko') }}
          </b-button>
        </template>
        <template v-else>
          <b-button variant="primary" size="md" @click="cancel()">
            <template v-if="btnOk">
              {{ btnOk }}
            </template>
            <template v-else>
              {{ $t('modal_custom_checkin_detail.btn_ok') }}
            </template>
          </b-button>
        </template>
      </div>
    </template>
  </b-modal>
</template>


<script>


export default {
  name: 'ModalCustomCheckinDetail',
  data() {
    return {
      modalId: 'modal-custom-checkin-detail',
    }
  },
  props: {
    param: {
      type: Object,
      required: false
    },
  },
  computed: {
    title() {
      return this.param.title
    },
    text() {
      return this.param.text
    },
    link() {
      return this.param.link
    },

    scroll() {
      return !this.param.config ? true : this.param.config.scroll
    },
    textCenter() {
      return !this.param.config ? false : this.param.config.textCenter
    },
    textClass() {
      return !this.param.config ? 'text-secondary' : this.param.config.textClass
    },
    ctas() {
      return this.param.ctas
    },
    btnOk() {
      return this.param.btnOk
    },
  }

}
</script>
